import React, { useState, useEffect, useContext, useRef } from "react";

import { Link } from "@reach/router";

import Logo from "@components/Logo";
import useBodyClass from "@utils/useBodyClass";
import { startingLocation } from "@utils/config";
import { useUrl } from "@utils/navigation";
import { getSupportedMode, setMode, useCurrentSettings } from "../PersistedData/settingsSlice";
import { NavigationContext } from "../TransitionRoot/NavigationContext";
import { useI18n } from "../../I18nextProvider";
import { useAppDispatch } from "../PersistedData/hooks";

enum HomeState {
  Unstarted,
  Starting
}

const Home = () => {
  const [state, setState] = useState(HomeState.Unstarted);
  const path = useUrl(startingLocation);
  const settings = useCurrentSettings();
  const { goto } = useContext(NavigationContext);
  const i18n = useI18n();
  const supported = getSupportedMode();
  const dispatch = useAppDispatch();
  const videoRef = useRef<HTMLVideoElement>();

  const srcVideo = require("../../assets/video/intro-v2.mp4");
  const srcPosterFrameIntro = require("../../assets/video/intro-posterframe.webp");

  useBodyClass("accueil", "");

  useEffect(() => {
    window.scrollTo(0, 0);
    const divRoot = document.getElementById("root");
    divRoot.classList.add("home");
    return () => {
      divRoot.classList.remove("home");
    };
  }, []);

  const close = () => {
    // TODO: Animate screen shutdown

    goto(path);
  };

  const start = (e?) => {
    if (settings.mode !== "noscript") {
      if (e) {
        e.preventDefault();
      }
      // Start sound & video event in basic mode
      setState(HomeState.Starting);
      close();
    }
  };

  /*
  let supportWarning = null;
  if (supported !== settings.mode) {
    supportWarning = (
      <p className="warning pulse">
        <span>
          {i18n.t("home.warning.settings")}&nbsp;
          <Link
            onClick={handle3dVersionClick}
            className="btn_disable3d"
            to={path}
            aria-label={i18n.t("home.btn_altversion")}
          >
            {i18n.t("home.warning.settingsClicActive")}
          </Link>
        </span>
      </p>
    );
  } else if (supported === "basic") {
    supportWarning = (
      <p className="warning pulse">
        <span>{i18n.t("home.warning.basic")}</span>
      </p>
    );
  } else if (supported === "noscript") {
    supportWarning = (
      <p className="warning pulse">
        <span>{i18n.t("home.warning.noscript")}</span>
      </p>
    );
  }
  */

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    if (video) {
      const { currentTime } = video;
      const { duration } = video;
      if (duration - currentTime <= 4.3) {
        video.playbackRate = 0.5;
      } else {
        video.playbackRate = 1;
      }
    }
  };

  return (
    <main className="home">
      <div className="bg-video home">
        <video
          id="bg-video-accueil"
          autoPlay
          loop
          muted
          crossOrigin="anonymous"
          playsInline
          onTimeUpdate={handleTimeUpdate}
          ref={videoRef}
          webkit-playsinline="true"
          poster={srcPosterFrameIntro}
        >
          <source src={srcVideo} type="video/mp4" />
        </video>
      </div>

      <section className="block-titre" id="maincontent" tabIndex={-1}>
        <div className="home-content">
          <h1 className="titre">{i18n.t("global.siteName")}</h1>
          <h2 className="soustitre">{i18n.t("home.subtitle")}</h2>
          <h3 className="desc">{i18n.t("home.description")}</h3>
          <p>
            <Link
              to={path}
              id="bouton-commencer"
              className={state === HomeState.Starting ? "starting btn-commencer" : "btn-commencer"}
              onClick={start}
              onTouchStart={start}
              onTouchEnd={start}
            >
              <span>{i18n.t("home.btn_commencer")}</span>
            </Link>
          </p>

          {/* supportWarning && <>{supportWarning}</> */}
        </div>
      </section>

      <section className="block-logos">
        <Logo />
      </section>
    </main>
  );
};

export default Home;
